// extracted by mini-css-extract-plugin
export default {"sourceBy":"iwD6rYFJjwCaMKUYIJNA"};